var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4113 26.75H9.58601C9.16537 26.75 8.76197 26.5766 8.46453 26.2679C8.1671 25.9593 8 25.5406 8 25.1041V11.3959C8 10.9594 8.1671 10.5407 8.46453 10.2321C8.76197 9.9234 9.16537 9.75 9.58601 9.75H16.1794C16.2886 9.75007 16.3966 9.77275 16.4973 9.81671C16.5979 9.86067 16.689 9.92504 16.7654 10.006L20.741 14.2121C20.9069 14.3876 20.9999 14.6237 21 14.8696V25.106C20.9998 25.3222 20.9585 25.5362 20.8785 25.7359C20.7985 25.9355 20.6814 26.1169 20.5339 26.2696C20.3864 26.4222 20.2113 26.5432 20.0187 26.6257C19.8261 26.7081 19.6197 26.7504 19.4113 26.75Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10V14.211C16 14.4203 16.0776 14.621 16.2158 14.7689C16.354 14.9169 16.5414 15 16.7368 15H21",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9571 6.70281C14.0997 6.5511 14.2831 6.47502 14.464 6.47502H19.8429V9.67198C19.8429 10.0676 20.0001 10.4471 20.2798 10.7268C20.5596 11.0066 20.939 11.1638 21.3347 11.1638H24.275L24.275 20.2843L24.275 20.285V20.285C24.2748 20.4002 24.2533 20.5133 24.2126 20.6175C24.1718 20.7218 24.1132 20.8138 24.0422 20.8892C24.0005 20.9334 23.9551 20.9714 23.9072 21.0028L22.9825 21.0252L23.0176 22.4748L24.1118 22.4483L24.2547 22.4448L24.3856 22.3874C24.6546 22.2693 24.896 22.0974 25.0974 21.8837C25.2987 21.67 25.4563 21.4187 25.5632 21.1451C25.67 20.8715 25.7247 20.5797 25.725 20.2858L25.725 20.285V10.5959V10.5957C25.7249 10.187 25.5746 9.78654 25.294 9.48223L25.2939 9.4821L21.6249 5.50173L21.6247 5.50156C21.4892 5.35417 21.3249 5.23435 21.1401 5.15154C20.9551 5.06864 20.7545 5.02515 20.5507 5.02502H20.5502H14.464C13.8684 5.02502 13.307 5.27722 12.9005 5.70983C12.4954 6.14092 12.275 6.71648 12.275 7.3079V7.75002H13.725V7.3079C13.725 7.07297 13.8131 6.85604 13.9571 6.70281ZM23.6736 9.86377L21.1429 7.11822V9.67198C21.1429 9.72285 21.1631 9.77163 21.1991 9.8076C21.235 9.84356 21.2838 9.86377 21.3347 9.86377H23.6736Z",
    fill: "currentColor",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.a51896b7390106acf81e6c10254e16de.svg";
export { ForwardRef as ReactComponent };